/* Zefra Fans — GSAP scroll animations
 * Waits for gsap + ScrollTrigger, honors prefers-reduced-motion.
 * Hooks: data-zf-reveal, data-zf-stagger, data-zf-parallax, data-zf-count.
 */
(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const ready = () =>
    new Promise((resolve) => {
      const check = () => {
        if (window.gsap && window.ScrollTrigger) return resolve();
        requestAnimationFrame(check);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', check, { once: true });
      } else {
        check();
      }
    });

  ready().then(() => {
    const { gsap, ScrollTrigger } = window;
    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power3.out' });

    // ---------- Reveal (fade + slide up) ----------
    document.querySelectorAll('[data-zf-reveal]').forEach((el) => {
      const dir = el.getAttribute('data-zf-reveal') || 'up';
      const from = { opacity: 0 };
      if (dir === 'up') from.y = 48;
      if (dir === 'down') from.y = -48;
      if (dir === 'left') from.x = 48;
      if (dir === 'right') from.x = -48;
      if (dir === 'scale') { from.scale = 0.94; from.y = 24; }

      gsap.fromTo(
        el,
        from,
        {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1,
          duration: 1.0,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
        }
      );
    });

    // ---------- Staggered children ----------
    document.querySelectorAll('[data-zf-stagger]').forEach((group) => {
      const selector = group.getAttribute('data-zf-stagger-target') || ':scope > *';
      const items = group.querySelectorAll(selector);
      if (items.length === 0) return;

      gsap.fromTo(
        items,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          stagger: 0.1,
          scrollTrigger: {
            trigger: group,
            start: 'top 82%',
            toggleActions: 'play none none none',
          },
        }
      );
    });

    // ---------- Parallax (translates Y slightly on scroll) ----------
    document.querySelectorAll('[data-zf-parallax]').forEach((el) => {
      const amount = parseFloat(el.getAttribute('data-zf-parallax')) || 60;
      gsap.fromTo(
        el,
        { y: -amount / 2 },
        {
          y: amount / 2,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        }
      );
    });

    // ---------- Text split (per line/word reveal) on big headings ----------
    document.querySelectorAll('[data-zf-heading]').forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 36, letterSpacing: '0.02em' },
        {
          opacity: 1,
          y: 0,
          letterSpacing: '0em',
          duration: 1.1,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 88%',
            toggleActions: 'play none none none',
          },
        }
      );
    });

    // ---------- Number countup ----------
    document.querySelectorAll('[data-zf-count]').forEach((el) => {
      const end = parseFloat(el.getAttribute('data-zf-count')) || parseFloat(el.textContent) || 0;
      const suffix = el.getAttribute('data-zf-count-suffix') || '';
      const decimals = parseInt(el.getAttribute('data-zf-count-decimals') || '0', 10);
      const obj = { v: 0 };
      gsap.to(obj, {
        v: end,
        duration: 1.6,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' },
        onUpdate: () => {
          el.textContent = obj.v.toFixed(decimals) + suffix;
        },
      });
    });

    // ---------- Refresh on theme editor events (Shopify section re-render) ----------
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => ScrollTrigger.refresh());
      document.addEventListener('shopify:section:unload', () => ScrollTrigger.refresh());
    }
  });
})();
